import { createAsyncThunk } from "@reduxjs/toolkit";
import { preLoginService } from "../../Services"; 

const getToken = () => {
    try {
        const u = JSON.parse(localStorage.getItem("user"));
        return u?.token || localStorage.getItem("token") || null;
    } catch {
        return localStorage.getItem("token") || null;
    }
};

export const fetchDashboardOrders = createAsyncThunk(
    "dashboard/fetchDashboardOrders",
    async ({ page = 1, limit = 10, filters }, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams();
            params.set("page", String(page));
            params.set("limit", String(limit));

            // add filters
            if (filters) {
                Object.entries(filters).forEach(([k, v]) => {
                    if (v !== undefined && v !== null && v !== "" && v !== "all") {
                        params.set(k, String(v));
                    }
                });
            }
            
            const url = `/api/orders/all/list?${params.toString()}`;

            // console.log("DASHBOARD ORDERS URL:", url);

            const token = getToken();

            const res = await preLoginService.get(
                url,
                token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
            );

            const payload = res?.data?.data ? res.data : res;

            return payload;
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message || err?.message || "Dashboard orders fetch failed"
            );
        }
    }
);
